module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-102__dfc950f40463ff9447305ce5e0fa27d2.png";